import { useCallback } from "react";
import { CardContentHeaderTitleProps } from "../../props/CardContentHeaderTitleProps"
import { useLongPress } from "use-long-press";
import { isMobile } from "../../../../helpers/DeviceHelpers";
import { useSwipeable } from "react-swipeable";
import { isNullOrEmpty } from "../../../../helpers/ObjectHelpers";
import { CopyToClipboard } from "../../../CopyToClipboard";
import parse from 'html-react-parser';

export const CardContentHeaderTitle = ({
    cardService,
    title = "",
    subTitle = "",
    subTitleClassName = "",
    dispatcherService,
    clipboardText = "",
    truncateSubTitle = true
}: CardContentHeaderTitleProps) => {
    const onTouchStartOrOnMouseDown = () => {
        cardService.onTouchStartOrOnMouseDown();
    }

    const onTouchEndOrOnMouseUp = async (e: any) => {
        if (!e) return;
        if (isMobile() && e.event.type === "touchend") {
            dispatcherService.onClick(cardService.isLeadingActionsOpened, cardService.cancelOnTouchEndOrOnMouseUp);
        }
        if (!isMobile() && e.event.type === "mouseup") {
            dispatcherService.onClick(cardService.isLeadingActionsOpened, cardService.cancelOnTouchEndOrOnMouseUp);
        }
    }

    const onMouseDown = (e: React.MouseEvent<HTMLElement>) => {
        if (isMobile()) return;
        cardService.onTouchStartOrOnMouseDown();
    }

    const onMouseUp = (e: React.MouseEvent<HTMLElement>) => {
        if (isMobile()) return;
        dispatcherService.onClick(cardService.isLeadingActionsOpened, cardService.cancelOnTouchEndOrOnMouseUp);
    }

    const touchHandlers = useSwipeable({
        onTouchStartOrOnMouseDown, // Called for `touchstart` and `mousedown`
        onTouchEndOrOnMouseUp,     // Called for `touchend` and `mouseup`
    });

    const longPressCallback = useCallback((e: any) => {
        cardService.onLongPress();
    }, []);
    const longPressHandlers = useLongPress(longPressCallback, {
        filterEvents: event => true, // All events can potentially trigger long press (same as 'undefined')
        threshold: 500, // In milliseconds
        captureEvent: true, // Event won't get cleared after React finish processing it
        cancelOnMovement: 25, // Square side size (in pixels) inside which movement won't cancel long press
        cancelOutsideElement: true, // Cancel long press when moved mouse / pointer outside element while pressing
        detect: 'pointer', // Default option
    });

    return (
        <div
            {...longPressHandlers()}
            {...touchHandlers}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            className="crd-content-header-title">
            <div
                className="crd-content-header-title-text font-size-xl">
                <div className="text-truncate">
                    {parse(title)}
                </div>
            </div>
            <div className="crd-content-header-title-clipboard">
                {
                    (!isNullOrEmpty(clipboardText)) &&
                    <CopyToClipboard text={clipboardText} />
                }
            </div>
            <div
                className={`crd-content-header-title-sub ${subTitleClassName} k-d-grid`}>
                <div className={`${truncateSubTitle ? "text-truncate" : ""}`}>
                    {subTitle}
                </div>
            </div>
        </div>
    )
}
